import {
  INewTicketAutomationReceivedCustomMessage,
  ITicketAutomationReceivedCustomMessage,
} from "../models/automation-received-custom-message";
import { GlobalAxios } from "./../axios/axios-config";

const TICKET_AUTOMATION_RECEIVED_SLOT_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedCustomMessage/";

export const createTicketAutomationReceivedCustomMessage = (
  item: INewTicketAutomationReceivedCustomMessage
) => {
  return GlobalAxios.post(TICKET_AUTOMATION_RECEIVED_SLOT_ROUTE, item);
};

export const getTicketAutomationReceivedCustomMessageById = (id: string) => {
  return GlobalAxios.get<ITicketAutomationReceivedCustomMessage>(
    TICKET_AUTOMATION_RECEIVED_SLOT_ROUTE + id
  );
};

export const updateTicketAutomationReceivedCustomMessageById = ({
  item,
  id,
}: {
  item: INewTicketAutomationReceivedCustomMessage;
  id: string;
}) => {
  return GlobalAxios.put(TICKET_AUTOMATION_RECEIVED_SLOT_ROUTE + id, item);
};
